"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const dashboardHeader_1 = __importDefault(require("./dashboardHeader"));
const DashboardContainer = ({ children }) => {
    const theme = (0, material_1.useTheme)();
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(dashboardHeader_1.default, {}), (0, jsx_runtime_1.jsx)(material_1.Container, { "data-testid": "dashboard-container", style: {
                    overflow: 'auto',
                    height: '100vh',
                    maxWidth: '100vw',
                    padding: `${theme.tsGoUnit.tsUnit}`,
                    backgroundColor: `${theme.palette.tsGoColor.grayLightest}`,
                }, children: children })] }));
};
exports.default = DashboardContainer;
